export const helloWorld = () => {
  app.activeDocument;
  alert("Hello from Photoshop");
};
